import {
    connect,
} from 'react-redux';

import CartItem from '../components/CartItem';

const mapStateToProps = ({ shop }, ownProps) => ({
    productSlug: ownProps.product,
    product: shop.products[ownProps.productSlug] || {},
});

const container = connect(
    mapStateToProps,
)(CartItem);

export default container;



// WEBPACK FOOTER //
// ./resources/components/shop/containers/CartItemContainer.js